export const EditIcon = () => {
  return (
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.082 3.66699H3.66536C3.17913 3.66699 2.71282 3.86015 2.369 4.20396C2.02519 4.54778 1.83203 5.0141 1.83203 5.50033V18.3337C1.83203 18.8199 2.02519 19.2862 2.369 19.63C2.71282 19.9738 3.17913 20.167 3.66536 20.167H16.4987C16.9849 20.167 17.4512 19.9738 17.7951 19.63C18.1389 19.2862 18.332 18.8199 18.332 18.3337V11.917'
        stroke='white'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M16.957 2.29122C17.3217 1.92655 17.8163 1.72168 18.332 1.72168C18.8478 1.72168 19.3424 1.92655 19.707 2.29122C20.0717 2.6559 20.2766 3.1505 20.2766 3.66622C20.2766 4.18195 20.0717 4.67655 19.707 5.04122L10.9987 13.7496L7.33203 14.6662L8.2487 10.9996L16.957 2.29122Z'
        stroke='white'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
